// removed by extract-text-webpack-plugin
module.exports = {"BodyText":"BodyText__1neZE","ErrorText":"ErrorText__JzWbr","BackLink":"BackLink__2FPU7","Title":"Title__1WP20","ArticlePage":"ArticlePage__3YfX_","ArticleContainer":"ArticleContainer__TouL5","ProfilePicture":"ProfilePicture__2FX64","ProfileMetaText":"ProfileMetaText__3a3Ly","ArticleTextContainer":"ArticleTextContainer__x6-KX"};


//////////////////
// WEBPACK FOOTER
// ./routes/HelpDesk/HelpDeskArticle/style.scss
// module id = ngBf
// module chunks = 0